import './config/amplifyConfig';  // Amplify must initialize before anything else
import React from 'react';
import {createRoot} from "react-dom/client";
import './styles/tokens.css';
import './styles/global.css';
import './styles/page-shell.css';
import './styles/rp-btn.css';
import './styles/list-primitives.css';
/* Shared page stylesheets, loaded once and before every page's own CSS (audit C11).
   Pages used to @import these into their own sheets, which pasted a copy per page and
   left the shared rules wherever the LAST copy fell, after almost every page. */
import './styles/dp-primitives.css';
import './styles/pp-primitives.css';
import './pages/community/areas/areas-page.css';
import './pages/community/residents/residents-page.css';
import './pages/reports/alert-details/alert-details-page.css';
import './pages/events/alerts/alerts-page.css';
import './pages/dashboard/main/main-dash-page.css';
import './pages/settings/wellness-settings/wellness-settings-page.css';
import "@fontsource/mulish";
import { ThemeProvider } from './contexts/ThemeContext.jsx';
import { PortalVersionProvider } from './contexts/PortalVersionContext.jsx';
import App from './App.jsx';
import { initSession } from './services/session';

// Decrypt the persisted session into memory before the first render, so the
// synchronous getSession() the app relies on for routing has data available.
// initSession never rejects (it clears the session on any failure).
initSession().finally(() => {
    const root = createRoot(document.getElementById("root"))
    root.render(
        <PortalVersionProvider>
            <ThemeProvider>
                <App />
            </ThemeProvider>
        </PortalVersionProvider>
    )
})
